import styled from '@emotion/styled'

export const ErrorMessage = styled.p`
  color: #cb1a1a;
`
